import Vue from 'vue'
import PurchaseDialog from '@/components/PurchaseDialog.vue'

const PurchaseConstructor = Vue.extend(PurchaseDialog)

let instance

const showPurchaseDialog = function() {
  if (!instance) {
    instance = new PurchaseConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
  instance.show()
}

export default {
  install(Vue) {
    Vue.prototype.$purchase = showPurchaseDialog
  }
} 